<template>
  <div
    class="table-loading-bar"
    role="status"
    aria-live="polite"
    :aria-label="$t('loading')"
  >
    <div class="table-loading-progress" aria-hidden="true">
      <span></span>
    </div>
    <span class="visually-hidden">{{ $t('loading') }}</span>
  </div>
</template>

<script>
export default {
  name: 'TableLoadingBar'
}
</script>

<style scoped>
.table-loading-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 72px;
  padding: 1rem;
}

.table-loading-progress {
  width: 148px;
  max-width: 100%;
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #dce8f7;
}

.table-loading-progress span {
  display: block;
  width: 42%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #004aad, #00a98f);
  animation: table-loading-progress 1.35s ease-in-out infinite;
}

@keyframes table-loading-progress {
  0% { transform: translateX(-110%); }
  50% { transform: translateX(75%); }
  100% { transform: translateX(250%); }
}

@media (prefers-reduced-motion: reduce) {
  .table-loading-progress span {
    width: 100%;
    animation: none;
  }
}
</style>
